/** CHECK-constrained contact_type values (delivery.contacts.contact_type). */ export const CONTACT_TYPE_OPTIONS = [
    {
        value: 'INTERNAL',
        label: 'Internal'
    },
    {
        value: 'GOVERNMENT',
        label: 'Government'
    },
    {
        value: 'EXTERNAL',
        label: 'External'
    }
];
export function contactTypeLabel(value) {
    if (!value) return 'Internal';
    return CONTACT_TYPE_OPTIONS.find((o)=>o.value === value)?.label ?? value;
}
/**
 * An empty contact_type reads as INTERNAL — the column default. This is a
 * business invariant every type-filtered picker relies on; don't re-derive it
 * at call sites.
 */ export function isInternalContact(c) {
    return (c.contactType || 'INTERNAL') === 'INTERNAL';
}
export function contactLabel(c) {
    return `${c.firstName ?? ''} ${c.lastName ?? ''}`.trim() || c.email || '';
}
/**
 * Keeps the currently-assigned contact selectable when a type filter would
 * hide it — a select whose stored value has no matching item renders blank and
 * forces an accidental reassignment on edit.
 */ export function withCurrentSelectable(filtered, currentId, all) {
    if (!currentId || filtered.some((c)=>c.id === currentId)) return filtered;
    const current = all.find((c)=>c.id === currentId);
    return current ? [
        ...filtered,
        current
    ] : filtered;
}
